export default __webpack_public_path__ + "static/media/pricingPageLocation.94ea627c.webp";